module.exports = __webpack_public_path__ + "static/author-site-photo-36ff92faaadebb91a76732e3df58bab6.jpg";